export const Mark = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path d="M6 2.5V15M9 18H21.5" stroke="currentColor" strokeWidth="1.75" strokeLinecap="square" />
    <path d="M6 14.5L9.5 18L6 21.5L2.5 18L6 14.5Z" fill="#0D9488" />
  </svg>
);

export const Wordmark = ({ className = "" }) => (
  <span
    className={`font-display text-[17px] font-semibold uppercase leading-none tracking-[0.2em] ${className}`}
  >
    AXORIS
  </span>
);
